import React, { useState } from 'react';

import { NavLink } from 'react-router-dom';

import Expand from '@assets/Icons/Expand';

import styles from './styles.module.scss';

interface DataChild {
  to: string;
  label: string;

  icon?: React.FC;
}

class NavItemsProps {
  children: React.ReactNode;

  dataChildren?: DataChild[];

  dataMainButton?: any | undefined;
}

const NavItems: React.FC<NavItemsProps> = ({ children, dataChildren, dataMainButton }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleAccordionClick = () => {
    setIsExpanded(!isExpanded);
  };

  if (dataChildren) {
    return (
      <>
        <div onClick={handleAccordionClick} className={styles.link}>
          {children}
          <Expand className={isExpanded ? styles.rotateArrow : ''} />
        </div>

        {isExpanded && (
          <ul className={styles.containerChildren}>
            {dataChildren?.map((item) => (
              <li key={item.to} className={styles.liChildren}>
                <NavLink to={item.to} className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ''}`}>
                  {item?.icon && <item.icon />}
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
      </>
    );
  } else {
    return (
      <>
        <NavLink to={dataMainButton?.to} className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}>
          {children}
          <span>{dataMainButton?.label}</span>
        </NavLink>
      </>
    );
  }
};
export default NavItems;
